// extracted by mini-css-extract-plugin
export default {"root":"NearMixedPairWarning_root__xdDVA","icon":"NearMixedPairWarning_icon__bI5eC","text":"NearMixedPairWarning_text__ozh4z","link":"NearMixedPairWarning_link__QnGcY"};